import { defineMessages } from 'react-intl';

export default defineMessages({
	amountDescription: {
		id: 'pages.walletPayment.FactorAmount.amountDescription',
		defaultMessage: 'مبلغ فاکتور مشتری را وارد کنید',
	},
	finalAmountTitle: {
		id: 'pages.walletPayment.FactorAmount.finalAmountTitle',
		defaultMessage: 'مبلغ نهایی:',
	},
	discountAmountTitle: {
		id: 'pages.walletPayment.FactorAmount.discountAmountTitle',
		defaultMessage: 'تخفیف ({discountPercent}%):',
	},
	buttonLabel: {
		id: 'pages.walletPayment.FactorAmount.buttonLabel',
		defaultMessage: 'مرحله بعد',
	},
	inputLabel: {
		id: 'pages.walletPayment.FactorAmount.inputLabel',
		defaultMessage: 'مبلغ فاکتور',
	},
});
